import React from 'react';
import { Chip } from '@mui/material';
import type { EmployeePayType } from '../../types/employee';
import { payTypeLabel } from '../../lib/payroll/display-helper';

const PAY_TYPE_COLORS: Record<EmployeePayType, { bg: string; color: string }> = {
  monthly: { bg: 'var(--bg-muted)', color: 'var(--fg-secondary)' },
  hourly: { bg: 'var(--primary-soft)', color: 'var(--primary-hover)' },
  dailyWorker: { bg: 'var(--bg-green)', color: 'var(--primary-hover)' },
  businessService: { bg: 'var(--c-cool-100)', color: 'var(--c-cool-900)' },
};

interface PayTypeBadgeProps {
  payType: EmployeePayType;
  size?: 'small' | 'medium';
}

const PayTypeBadge: React.FC<PayTypeBadgeProps> = ({ payType, size = 'small' }) => {
  const colors = PAY_TYPE_COLORS[payType];
  return (
    <Chip
      label={payTypeLabel(payType)}
      size={size}
      sx={{
        bgcolor: colors.bg,
        color: colors.color,
        fontWeight: 600,
        fontSize: size === 'small' ? '0.8125rem' : '0.875rem',
        height: size === 'small' ? 28 : 32,
      }}
    />
  );
};

export default PayTypeBadge;
